import * as React from "react";
import mitt from "mitt";

export const emitterOrg = mitt();
export const emitterOrgContext = React.createContext(emitterOrg);

export function useOrgEmitter() {
  return React.useContext(emitterOrgContext);
}
